/**
 * Formatea valores de potencia de manera inteligente:
 * - Si >= 1000 W, muestra en kW con 2 decimales
 * - Si < 1000 W, muestra en W sin decimales
 */
export const formatPower = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0 W';
  }
  
  const absValue = Math.abs(value);
  
  if (absValue >= 1000) {
    return `${(value / 1000).toFixed(2)} kW`;
  } else {
    return `${Math.round(value)} W`;
  }
};

/**
 * Formatea valores de energía de manera inteligente:
 * - Si >= 1 kWh, muestra en kWh con 2 decimales
 * - Si < 1 kWh, muestra en Wh sin decimales
 */
export const formatEnergy = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0 Wh';
  }
  
  const absValue = Math.abs(value);
  
  if (absValue >= 1) {
    return `${value.toFixed(2)} kWh`;
  } else {
    return `${Math.round(value * 1000)} Wh`;
  }
};







